module.exports = __webpack_public_path__ + "static/media/main_banner_en.11976280.jpg";